import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { viewBox: "0 0 40 40" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "20",
      cy: "20",
      r: "20",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M22.0307 18.6474L21.1517 17.4006C22.6348 15.5192 24.3511 14.0002 26.8547 14.0002C28.6086 13.9872 30.2833 14.7052 31.4512 15.9708C32.6191 17.2364 33.1672 18.927 32.9553 20.611H25.6999V19.1889H31.464C31.0874 17.0118 29.1371 15.4179 26.8547 15.4222C24.8334 15.4222 23.3891 16.8442 22.0307 18.6474ZM13.2842 14.0002C16.3841 14.0002 18.3828 16.2226 20.4998 19.2652C22.6169 22.3078 24.2848 24.3815 26.8124 24.3815C28.5536 24.3856 30.16 23.4881 31.0079 22.0377H32.6713C31.7117 24.3195 29.3901 25.8123 26.8124 25.8052C23.7125 25.8052 21.7948 23.6784 19.5923 20.5349C17.3897 17.3914 15.8118 15.4235 13.2842 15.4235C10.6707 15.4063 8.5356 17.4098 8.51102 19.9024C8.53524 22.3951 10.6703 24.3988 13.2839 24.3818C15.3502 24.3818 16.8265 22.9625 18.2153 21.158L19.1075 22.413C17.5923 24.2911 15.8398 25.8052 13.2842 25.8052C9.84145 25.8264 7.03024 23.1859 7 19.9024C7.03059 16.6191 9.84169 13.9789 13.2842 14.0002Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }